import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppService } from './app.service';
import { state2 } from './state';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

export interface ICodeIdOmschrijving {
  Id: number;
  Omschrijving: string;
}

export interface IAppGlobalData {
  CebanArchiefUrl: string;
  HasCebanArchief: boolean;
  PdfDownloadAllowed: boolean;
  PdfUseInlinePdfViewer: boolean;
  AppVersion:string;
}

@Injectable({
  providedIn: 'root'
})
export class GlobalDataService {

  constructor(private http: HttpClient, private appService: AppService) { 
    const url = this.appService.getUrl('api/GlobalData/GetAppGlobalData');
    this.globalAppData$ = this.http.get<IAppGlobalData>(url).pipe(
      shareReplay({bufferSize:1, refCount:false})
    );
  }

  private soortenZitting$ = this.http.post<ICodeIdOmschrijving[]>(this.appService.getUrl('api/GlobalData/GetSoortenZitting'), {}).pipe(shareReplay({ bufferSize: 1, refCount: false }));
  getSoortenZitting(): Observable<ICodeIdOmschrijving[]> {
    const url = this.appService.getUrl('api/GlobalData/GetSoortenZitting');
    // return state2.getValueOrDefault('soortenzitting',this.http.post<ICodeIdOmschrijving[]>(url,{}));
    return this.soortenZitting$;
  }
  getPartijen(): Observable<ICodeIdOmschrijving[]> {
    const url = this.appService.getUrl('api/GlobalData/GetPartijen');
    return state2.getValueOrDefault('partijen', this.http.post<ICodeIdOmschrijving[]>(url, {}));
  }

  private globalAppData$ : Observable<IAppGlobalData>;
  getAppGlobalData() {
    return this.globalAppData$;
  }
  getHasChanged() {
    const url = this.appService.getUrl('home/haschanged').replace('/Proxy/Api', '');
    return this.http.post<number>(url, {});
  }
  lastTime: number;
  checkAutoReload() {
    this.getHasChanged().subscribe(result => {
      this.lastTime = result;
      setInterval(() => {
        this.getHasChanged().subscribe(result1 => {
          if (result1 > this.lastTime) {
            this.lastTime = result1;
            window.location.reload();
          }
        });
      }, 1000);
    });
  }

  


}
